import React from 'react'

const Myquote = () => {
  return (
    <div>
      
    </div>
  )
}

export default Myquote
